/**
 * @generated SignedSource<<d9bb59c41d08cb9458aeee7dd48d449b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ClientSortBy = "DATE_ADDED_ASC" | "DATE_ADDED_DESC" | "LAST_ACTIVE_ASC" | "LAST_ACTIVE_DESC" | "NAME_ASC" | "NAME_DESC" | "PROGRAM_END_ASC" | "PROGRAM_END_DESC" | "PROGRESS_ASC" | "PROGRESS_DESC" | "%future added value";
export type ClientStatusFilter = "ACTIVE" | "ADDED" | "ARCHIVED" | "PENDING" | "%future added value";
export type CoachClientsListRouteQuery$variables = {
  sort: ClientSortBy;
  status?: ReadonlyArray<ClientStatusFilter> | null | undefined;
  tag?: string | null | undefined;
};
export type CoachClientsListRouteQuery$data = {
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"CoachClientsListScreen_user">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"CoachClientsListScreen_addedUsers" | "CoachClientsListScreen_invitedUsers" | "CoachClientsListScreen_root">;
};
export type CoachClientsListRouteQuery = {
  response: CoachClientsListRouteQuery$data;
  variables: CoachClientsListRouteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tag"
},
v3 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "status"
},
v4 = {
  "kind": "Variable",
  "name": "tagId",
  "variableName": "tag"
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "current",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clientStatus",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoURL",
  "storageKey": null
},
v16 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "fromNow"
  }
],
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "client",
  "plural": false,
  "selections": [
    (v14/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "kind": "Literal",
  "name": "first",
  "value": 9999
},
v19 = [
  {
    "kind": "Literal",
    "name": "addedUser",
    "value": false
  },
  (v18/*: any*/)
],
v20 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "InviteEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Invite",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v5/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "format",
                "value": "MMMM Do"
              }
            ],
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": "createdAt(format:\"MMMM Do\")"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v21 = [
  {
    "kind": "Literal",
    "name": "addedUser",
    "value": true
  },
  (v18/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CoachClientsListRouteQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "CoachClientsListScreen_root"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CoachClientsListScreen_invitedUsers"
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "CoachClientsListScreen_addedUsers"
      },
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CoachClientsListScreen_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "CoachClientsListRouteQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TagConnection",
        "kind": "LinkedField",
        "name": "tags",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TagEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Tag",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          },
          {
            "kind": "Variable",
            "name": "orderBy",
            "variableName": "sort"
          },
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "previous",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "page",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageCursor",
                "kind": "LinkedField",
                "name": "next",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v8/*: any*/),
              {
                "alias": "client",
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "tag",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": (v16/*: any*/),
                    "kind": "ScalarField",
                    "name": "lastLoginAt",
                    "storageKey": "lastLoginAt(format:\"fromNow\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endPrograms",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Invite",
                    "kind": "LinkedField",
                    "name": "invite",
                    "plural": false,
                    "selections": [
                      (v17/*: any*/),
                      (v5/*: any*/),
                      (v11/*: any*/),
                      {
                        "alias": "invitedAt",
                        "args": (v16/*: any*/),
                        "kind": "ScalarField",
                        "name": "updatedAt",
                        "storageKey": "updatedAt(format:\"fromNow\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "allClients",
        "args": [
          (v18/*: any*/),
          (v3/*: any*/)
        ],
        "concreteType": "ClientConnection",
        "kind": "LinkedField",
        "name": "clients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClientEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": "client",
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v15/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "InviteCode",
        "kind": "LinkedField",
        "name": "inviteCode",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "invitedUsers",
        "args": (v19/*: any*/),
        "concreteType": "InviteConnection",
        "kind": "LinkedField",
        "name": "invites",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": "invites(addedUser:false,first:9999)"
      },
      {
        "alias": "invitedUsers",
        "args": (v19/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ClientInvites_invitedUsers",
        "kind": "LinkedHandle",
        "name": "invites"
      },
      {
        "alias": "addedUsers",
        "args": (v21/*: any*/),
        "concreteType": "InviteConnection",
        "kind": "LinkedField",
        "name": "invites",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": "invites(addedUser:true,first:9999)"
      },
      {
        "alias": "addedUsers",
        "args": (v21/*: any*/),
        "filters": [],
        "handle": "connection",
        "key": "ClientInvites_addedUsers",
        "kind": "LinkedHandle",
        "name": "invites"
      },
      {
        "alias": "user",
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": "clientsCountNoSample",
            "args": [
              {
                "kind": "Literal",
                "name": "noSample",
                "value": true
              }
            ],
            "kind": "ScalarField",
            "name": "clientsCount",
            "storageKey": "clientsCount(noSample:true)"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "plan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "planTier",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b483382ec415f2c378ea871a85de6125",
    "id": null,
    "metadata": {},
    "name": "CoachClientsListRouteQuery",
    "operationKind": "query",
    "text": "query CoachClientsListRouteQuery(\n  $status: [ClientStatusFilter!]\n  $sort: ClientSortBy!\n  $tag: ID\n) {\n  ...CoachClientsListScreen_root_G6cut\n  ...CoachClientsListScreen_invitedUsers\n  ...CoachClientsListScreen_addedUsers\n  user: me {\n    ...CoachClientsListScreen_user\n    id\n  }\n}\n\nfragment ClientCard_client on User {\n  id\n  email\n  username\n  tag {\n    title\n    id\n  }\n  displayName\n  clientStatus\n  photoURL\n  lastLoginAt(format: \"fromNow\")\n  endPrograms\n}\n\nfragment ClientMenu_client on User {\n  id\n  clientStatus\n}\n\nfragment ClientPendingCard_invite on Invite {\n  id\n  email\n  invitedAt: updatedAt(format: \"fromNow\")\n  client {\n    clientStatus\n    id\n  }\n}\n\nfragment CoachClientsListScreen_addedUsers on Root {\n  addedUsers: invites(first: 9999, addedUser: true) {\n    ...InviteDialog_addedUsers\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CoachClientsListScreen_invitedUsers on Root {\n  invitedUsers: invites(first: 9999, addedUser: false) {\n    ...InviteDialog_invitedUsers\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment CoachClientsListScreen_root_G6cut on Root {\n  tags {\n    edges {\n      node {\n        id\n        title\n      }\n    }\n  }\n  clients(first: 10, status: $status, orderBy: $sort, tagId: $tag) {\n    pageCursors {\n      ...ConnectionPagination_pageCursors\n    }\n    totalCount\n    edges {\n      cursor\n      client: node {\n        id\n        ...ClientCard_client\n        ...ClientMenu_client\n        ...CoachMessageClientsDialog_clients\n        invite {\n          client {\n            clientStatus\n            id\n          }\n          ...ClientPendingCard_invite\n          id\n        }\n      }\n    }\n  }\n  allClients: clients(first: 9999, status: $status) {\n    edges {\n      client: node {\n        id\n        ...CoachMessageClientsDialog_clients\n      }\n    }\n  }\n  inviteCode {\n    ...InviteDialog_inviteCode\n    id\n  }\n}\n\nfragment CoachClientsListScreen_user on User {\n  clientsCountNoSample: clientsCount(noSample: true)\n  plan\n  planTier\n}\n\nfragment CoachMessageClientsDialog_clients on User {\n  id\n  username\n  displayName\n  photoURL\n}\n\nfragment ConnectionPagination_pageCursors on PageCursors {\n  previous {\n    current\n    cursor\n  }\n  around {\n    current\n    cursor\n    page\n  }\n  next {\n    current\n    cursor\n  }\n}\n\nfragment InviteCodePreviewDialog_inviteCode on InviteCode {\n  code\n}\n\nfragment InviteDialog_addedUsers on InviteConnection {\n  totalCount\n  edges {\n    node {\n      client {\n        clientStatus\n        id\n      }\n      id\n    }\n  }\n  ...PendingInvitesList_invites\n}\n\nfragment InviteDialog_inviteCode on InviteCode {\n  ...InviteLinkSettings_inviteCode\n  ...InviteCodePreviewDialog_inviteCode\n  code\n}\n\nfragment InviteDialog_invitedUsers on InviteConnection {\n  totalCount\n  edges {\n    node {\n      client {\n        clientStatus\n        id\n      }\n      id\n    }\n  }\n  ...PendingInvitesList_invites\n}\n\nfragment InviteLinkSettings_inviteCode on InviteCode {\n  id\n  code\n}\n\nfragment PendingInviteItem_invite on Invite {\n  id\n  email\n  source\n  createdAt(format: \"MMMM Do\")\n  client {\n    id\n    clientStatus\n  }\n}\n\nfragment PendingInvitesList_invites on InviteConnection {\n  edges {\n    node {\n      id\n      ...PendingInviteItem_invite\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e1a8b0bc78ea8c827fa0fd14a5a34c51";

export default node;
